import {
    PRIMARY_COLOR_DarkNavyBlue,
    SECONDARY_COLOR_DarkMaroon,
} from "../constants/Colors";


const palette = {
    type: 'light',
    primary: {
        main: PRIMARY_COLOR_DarkNavyBlue,
    },
    secondary: {
        main: SECONDARY_COLOR_DarkMaroon,
    },
    transparent: {
        main: 'transparent'
    },
}

export default palette